// extracted by mini-css-extract-plugin
export default {"error":"OrganizationEdit_error_AdcRA","grid":"OrganizationEdit_grid_u6Fwb"};